<!-- Template para Materiales por Cliente usando smart-grid -->
<div class="client-materials-container w-full">
  <!-- Header with Export All Button -->
  <div class="flex justify-end mb-4">
    <button
      mat-icon-button
      color="primary"
      (click)="onExportButtonPressed()"
      matTooltip="Exportar todos los materiales a Excel">
      <mat-icon [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
    </button>
  </div>

  <!-- Main Materials Grid -->
  <div class="w-full bg-white">
    <app-smart-grid
      [data]="groupedMaterialsWithCustomers"
      [columnDefs]="materialColumnDefs"
      [config]="materialGridConfig"
      [detailTemplate]="customerExpansionTemplate"
      (pageChanged)="onMaterialPageChanged($event)"
      (sortChanged)="onMaterialSortChanged($event)"
      (rowExpansionChanged)="onMaterialRowExpanded($event)">

      <!-- Row Expansion Template for Customers -->
      <ng-template #customerExpansionTemplate let-row>
        <div class="mx-auto p-4 bg-white dark:bg-gray-900 overflow-hidden"
             [ngClass]="{
               'max-w-[calc(100vw-200px)]': isNavOpened,
               'max-w-[calc(100vw-80px)]': !isNavOpened
             }">
          <div class="ml-2 overflow-x-auto">
            <app-smart-grid
              [data]="expandedCustomerData"
              [columnDefs]="customerColumnDefs"
              [config]="customerGridConfig">
            </app-smart-grid>

            <!-- Empty State for Customers -->
            <div *ngIf="!expandedCustomerData || expandedCustomerData.length === 0"
                 class="border-t p-8 text-center text-sm">
              No hay clientes para mostrar.
            </div>
          </div>
        </div>
      </ng-template>
    </app-smart-grid>

    <!-- Empty State for Materials -->
    <div *ngIf="!groupedMaterialsWithCustomers || groupedMaterialsWithCustomers.length === 0"
         class="border-t p-8 text-center text-1xl sm:p-10">
      Lo sentimos, no hay registros para mostrar.
    </div>
  </div>
</div>
